;(function () {
  /* neverover — sticky Add-to-cart bar (PDP). Appears once the main Add-to-cart scrolls out of
     view; shows featured image · category · title · CTA-with-live-price. Clicking the CTA fires
     the real product-form button (which opens the size/variant drawer on mobile). Replaces the
     theme's own mobile sticky button. Pure JS + CSS; reads the existing PDP DOM. */
  if (window.__nvStickyAtc) return;
  window.__nvStickyAtc = true;

  function clean(s){ return (s == null ? '' : String(s)).replace(/tax\s*incl\.?/ig, '').replace(/\s+/g, ' ').trim(); }
  function priceText(el){
    if (!el) return '';
    var c = el.cloneNode(true);
    var j = c.querySelectorAll('.extra-tax,.product-price__tax,.price__tax,.tax-note,.price-item--tax,.unit-price,.product-price__old-price');
    for (var i = 0; i < j.length; i++) j[i].remove();
    return clean(c.textContent);
  }
  function mainBtn(){ return document.querySelector('button[name="add"][id*="MainSection"]') || document.querySelector('button[name="add"]'); }
  function sentinel(){ var b = mainBtn(); return b ? (b.closest('.product-form__btn-wrapper') || b) : null; }
  function priceEl(){ return document.querySelector('.product-price-wrapper .product-price__current-price') || document.querySelector('.product-price__current-price'); }
  function titleText(){ var h = document.querySelector('.product-general-info-block h1, .product__info h1, h1.caption1, h1'); return h ? clean(h.textContent) : ''; }
  function categoryText(){
    var bc = document.querySelector('.product-breadcrumbs-block, product-breadcrumbs, [class*="breadcrumb"]');
    if (bc){
      var a = bc.querySelector('a'); if (a && clean(a.textContent)) return clean(a.textContent);
      var t = clean(bc.textContent); if (t.indexOf('/') > -1) return clean(t.split('/')[0]);
    }
    return '';
  }
  function imgSrc(){
    var i = document.querySelector('product-media .product-media-grid__item img.shape__target-image')
         || document.querySelector('.product-media-grid img.shape__target-image')
         || document.querySelector('.product-media-grid img, .product-media img');
    return i ? (i.currentSrc || i.src || '') : '';
  }

  var bar, elImg, elCat, elTitle, elPrice, elCta;
  function build(){
    if (bar) return;
    bar = document.createElement('div');
    bar.className = 'nv-satc';
    bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML =
      '<div class="nv-satc__inner">' +
        '<img class="nv-satc__img" alt="" loading="lazy">' +
        '<div class="nv-satc__txt"><span class="nv-satc__cat"></span><span class="nv-satc__title"></span></div>' +
        '<button type="button" class="nv-satc__cta btn btn--solid">' +
          '<span class="nv-satc__cta-label">Add to cart</span><span class="nv-satc__price"></span>' +
        '</button>' +
      '</div>';
    document.body.appendChild(bar);
    elImg = bar.querySelector('.nv-satc__img');
    elCat = bar.querySelector('.nv-satc__cat');
    elTitle = bar.querySelector('.nv-satc__title');
    elPrice = bar.querySelector('.nv-satc__price');
    elCta = bar.querySelector('.nv-satc__cta');
    elCta.addEventListener('click', function (e){
      e.preventDefault();
      if (window.matchMedia('(max-width:767px)').matches){
        var b = mainBtn(); if (b) b.click();   // mobile: opens the variant drawer (.content)
        return;
      }
      // desktop: scroll to the size dropdown, then fire the REAL Add-to-cart so the theme's
      // own "pick a size" guard kicks in — red outline on the dropdown + red "Select your size"
      // label (it also opens the dropdown). If a size is already chosen, it just adds to cart.
      var picker = document.querySelector('variant-picker[id*="MainSection"]') || document.querySelector('variant-picker');
      var op = (picker && picker.querySelector('dropdown-opener[data-size-input="true"]')) || document.querySelector('dropdown-opener[data-size-input="true"]');
      var target = op || picker;
      if (target){ try { target.scrollIntoView({ behavior:'smooth', block:'center' }); } catch (e2){ target.scrollIntoView(); } }
      setTimeout(function(){ var b2 = mainBtn(); if (b2) b2.click(); }, 400);
    });
  }
  function fill(){
    if (!bar) return;
    var s = imgSrc(); if (s && elImg.getAttribute('src') !== s) elImg.setAttribute('src', s);
    var c = categoryText(); if (c && elCat.textContent !== c) elCat.textContent = c;
    var t = titleText(); if (t && elTitle.textContent !== t) elTitle.textContent = t;
    var p = priceText(priceEl()); if (p){ var pt = ' — ' + p; if (elPrice.textContent !== pt) elPrice.textContent = pt; }
  }
  function show(on){
    if (!bar) return;
    // expose the bar's real height so other fixed UI (chat button) can sit above it
    if (on) document.documentElement.style.setProperty('--nv-satc-h', bar.offsetHeight + 'px');
    bar.classList.toggle('nv-satc--on', !!on);
    document.body.classList.toggle('nv-satc-on', !!on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }

  var drawerOpen = false, scrollWired = false;
  function evaluate(){
    // synchronous (no rAF) so it works even when the tab is backgrounded (rAF pauses there).
    // cheap: one getBoundingClientRect + a class toggle; browsers coalesce scroll events.
    var sen = sentinel();
    if (!sen){ show(false); return; }
    // show once the real Add-to-cart has scrolled fully above the viewport top
    show(sen.getBoundingClientRect().bottom <= 0 && !drawerOpen);
  }
  function wire(){
    if (!sentinel()) return;
    build(); fill();
    if (!scrollWired){
      scrollWired = true;
      window.addEventListener('scroll', evaluate, { passive: true });
      window.addEventListener('resize', evaluate, { passive: true });
    }
    evaluate();
    var pw = document.querySelector('.product-price-wrapper');
    if (pw && !pw._nvSatc){ pw._nvSatc = 1; new MutationObserver(fill).observe(pw, { subtree: true, childList: true, characterData: true }); }
  }
  // hide the bar while the variant drawer is open (it overlays from the bottom too)
  window.addEventListener('pdr:opened', function(){ drawerOpen = true; show(false); });
  window.addEventListener('pdr:closed', function(){ drawerOpen = false; evaluate(); });
  window.addEventListener('pdr:close',  function(){ drawerOpen = false; evaluate(); });

  function boot(){
    if (!document.querySelector('.product-form-block, .product-form__btn-wrapper')) return; // PDP only
    wire();
  }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
